import { matchPath } from 'react-router';

import { NavRouteConfig, RouteConfig } from './types';

export const getPathname = (path: string): string => {
  if (!path.includes('?')) {
    return path;
  }

  try {
    const url = new URL(path, window.location.origin);
    return url.pathname;
  } catch {
    // This is a fallback snippet for malformed or relative paths
    return path.split('?')[0];
  }
};

export const validateLastVisited = (routes: (NavRouteConfig | RouteConfig)[], path: string): boolean => {
  const pathname = getPathname(path);

  for (const route of routes) {
    if (route.routePath && matchPath({ path: route.routePath, end: true }, pathname)) {
      return true;
    }

    if (route.subRoutes && route.subRoutes.length > 0) {
      if (validateLastVisited(route.subRoutes, pathname)) {
        return true;
      }
    }
  }

  return false;
};
